import Icon from "@/components/icons";

interface LeadFormContextProps {
  showContext: boolean;
  showTitle: boolean;
  title: string;
  content: string;
  icon: string;
  position: string;
  targetPosition: "above" | "below";
}

export default function LeadFormContext({
  showContext,
  showTitle,
  title,
  content,
  icon,
  position,
  targetPosition,
}: LeadFormContextProps) {
  if (!showContext) {
    return null;
  }
  if (position !== targetPosition) {
    return null;
  }

  return (
    <div className="bg-info-100 w-full rounded-xl border border-putty-400 py-3 px-4 lg:py-6 lg:px-10">
      <div className="flex gap-4">
        {icon && (
          <div className="flex-shrink-0">
            <Icon type={icon} svgProps={{ className: "h-6 w-6" }} />
          </div>
        )}
        <div className="flex flex-col gap-3">
          {showTitle && title && (
            <h6 className="elm-h6 text-gray-800 font-semibold">{title}</h6>
          )}
          {content && <p className="elm-p4 text-gray-800 !mb-0">{content}</p>}
        </div>
      </div>
    </div>
  );
}
